import $ from 'sbf-design-system/js/jquery';

$('a[href="#header"]').on('click', (e) => {
  e.preventDefault();
  window.scrollTo({
      top: 0,
      behavior: 'smooth'
  });
});